import { render, staticRenderFns } from "./SlideTime.vue?vue&type=template&id=124d2ef6&scoped=true&"
import script from "./SlideTime.vue?vue&type=script&lang=js&"
export * from "./SlideTime.vue?vue&type=script&lang=js&"
import style0 from "./SlideTime.vue?vue&type=style&index=0&id=124d2ef6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124d2ef6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Typography: require('/opt/build/repo/components/Typography.vue').default})
